module.exports = __webpack_public_path__ + "static/img/hg3.1c6bee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hg3.jpg
// module id = nLP+
// module chunks = 1